<template>
  <div>
    <order-list />
  </div>
</template>
<script>
import OrderList from "@/components/order_management/OrderList.vue";
export default {
  components: {
    OrderList
  }
};
</script>
